import 'sentry';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import { version } from '../package.json';

console.warn('version', version);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(async (module) => {
    if (navigator.serviceWorker && environment.SERVICE_WORKER) {
      await navigator.serviceWorker
        .register('./ngsw-worker.js', { scope: location.pathname })
        .catch((err) => console.error('Service worker registration failed', err));
    }

    return module;
  })
  .catch((err) => console.error(err));
